module.exports = __webpack_public_path__ + "img/assertiveness_letGo.22aabff7.png";